export const SURFACE_DEVICES = [
  // Surface (First Gen to Surface 3)
  "1516", // Surface RT (2012)
  "1514", // Surface Pro (2013)
  "1566", // Surface 2 (2013)
  "1631", // Surface Pro 2 (2013)
  "1645", // Surface 3 (2015)
  "1657", // Surface 3 LTE (2015)

  // Surface Pro Series
  "1796", // Surface Pro (5th Gen, 2017)
  "1807", // Surface Pro (5th Gen) LTE
  "1735", // Surface Pro 4 (2015)
  "1866", // Surface Pro 6 (2018)
  "1867", // Surface Pro 6 LTE
  "1986", // Surface Pro 7 (2019)
  "2019", // Surface Pro 7+ (2021)
  "1960", // Surface Pro X (2019)
  "1876", // Surface Pro X (2020) SQ1/SQ2 Processor
  "1983", // Surface Pro 8 (2021)
  "2564", // Surface Pro 9 (2022) Intel
  "2565", // Surface Pro 9 (2022) 5G

  // Surface Laptop Series
  "1868", // Surface Laptop 3 (13.5-inch, Intel, 2019)
  "1872", // Surface Laptop 3 (15-inch, AMD, 2019)
  "1951", // Surface Laptop 4 (13.5-inch, Intel/AMD, 2021)
  "1950", // Surface Laptop 4 (15-inch, Intel/AMD, 2021)
  "2520", // Surface Laptop 5 (13.5-inch, 2022)
  "2521", // Surface Laptop 5 (15-inch, 2022)
  "2569", // Surface Laptop Studio (2021)
  "2587", // Surface Laptop Studio 2 (2023)

  // Surface Book Series
  "1703", // Surface Book (1st Gen, 2015)
  "1705", // Surface Book with Performance Base (2016)
  "1832", // Surface Book 2 (13.5-inch, 2017)
  "1834", // Surface Book 2 (15-inch, 2017)
  "1899", // Surface Book 3 (13.5-inch, 2020)
  "1900", // Surface Book 3 (15-inch, 2020)

  // Surface Go Series
  "1824", // Surface Go (1st Gen, 2018)
  "1926", // Surface Go 2 (2020)
  "2007", // Surface Go 3 (2021)
  "2568", // Surface Go 4 (2023)

  // Surface Duo Series
  "1930", // Surface Duo (2020)
  "2469", // Surface Duo 2 (2021)

  // Surface Studio Series
  "1134", // Surface Studio (1st Gen, 2016)
  "1769", // Surface Studio 2 (2018)
  "2360", // Surface Studio 2+ (2022)
];
